import {
  INVALID_ACCOUNT_TYPE,
  INVALID_FINANCIAL_INSTITUTION_NUMBER,
  INVALID_BRANCH_NUMBER,
  INVALID_CANADA_EFT_LAST_FOUR,
  INVALID_ACCOUNT_FIRSTNAME,
  INVALID_ACCOUNT_LASTNAME,
  INVALID_ACCOUNT_NUMBER,
  MISSING_ACCOUNT_TYPE,
  MISSING_ACCOUNT_FIRSTNAME,
  MISSING_ACCOUNT_LASTNAME,
  MISSING_ACCOUNT_NUMBER,
  MISSING_FINANCIAL_INSTITUTION_NUMBER,
  MISSING_BRANCH_NUMBER,
  MISSING_CANADA_EFT_LAST_FOUR,
} from '../../../constants/error-codes';

export default {
  firstName: [
    INVALID_ACCOUNT_FIRSTNAME,
    MISSING_ACCOUNT_FIRSTNAME,
  ],
  lastName: [
    INVALID_ACCOUNT_LASTNAME,
    MISSING_ACCOUNT_LASTNAME,
  ],
  institutionNumber: [
    INVALID_FINANCIAL_INSTITUTION_NUMBER,
    MISSING_FINANCIAL_INSTITUTION_NUMBER,
  ], // for EFT type
  branchNumber: [
    INVALID_BRANCH_NUMBER,
    MISSING_BRANCH_NUMBER,
  ], // for EFT type
  accountNumber: [
    INVALID_CANADA_EFT_LAST_FOUR,
    MISSING_CANADA_EFT_LAST_FOUR,
    INVALID_ACCOUNT_NUMBER,
    MISSING_ACCOUNT_NUMBER,
  ],
  accountType: [
    INVALID_ACCOUNT_TYPE,
    MISSING_ACCOUNT_TYPE,
  ],
};
